'use client';

import type { LucideIcon } from 'lucide-react';

// Encabezado "hero" compartido por las vistas del módulo: el mismo lenguaje
// visual del hero de bienvenida del Inicio (degradado verde institucional
// radiante + círculos difuminados), con el ícono de la vista en una placa
// translúcida, el título y la descripción. `acciones` (opcional) se alinea a
// la derecha (p. ej. un botón Actualizar). Las vistas de Usuarios NO lo usan:
// tienen su propio encabezado (diseño de referencia Lex Control).
export default function HeroVista({
  icono: Icono,
  titulo,
  descripcion,
  acciones,
}: {
  icono: LucideIcon;
  titulo: React.ReactNode;
  descripcion?: React.ReactNode;
  acciones?: React.ReactNode;
}) {
  return (
    <section className="relative overflow-hidden rounded-xl bg-gradient-to-br from-primary via-green-700 to-green-950 p-6 text-primary-foreground shadow-sm">
      <div className="pointer-events-none absolute -right-12 -top-20 size-56 rounded-full bg-white/10 blur-2xl" />
      <div className="pointer-events-none absolute -bottom-24 right-32 size-64 rounded-full bg-emerald-300/10 blur-3xl" />
      <div className="relative flex flex-wrap items-center gap-4">
        <span className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-white/15 ring-1 ring-white/25">
          <Icono className="size-6" />
        </span>
        <div className="min-w-0 flex-1 basis-64">
          <h1 className="text-2xl font-semibold tracking-tight">{titulo}</h1>
          {descripcion && (
            <p className="mt-0.5 text-sm text-primary-foreground/75">{descripcion}</p>
          )}
        </div>
        {acciones && <div className="flex shrink-0 items-center gap-2">{acciones}</div>}
      </div>
    </section>
  );
}
